/* import __COLOCATED_TEMPLATE__ from './test-failure-expected-hint.hbs'; */
import Component from '@glimmer/component';

type Signature = {
  Element: HTMLDivElement;
};

export default class TestFailureExpectedComponent extends Component<Signature> {}
